<template>
  <div class="div_wxLogin">
    <h3 class="h3_title">微信快捷登录</h3>
    <h5 class="p_explain">微信扫一扫，关注公众号登录，新用户需要手机号验证</h5>
    <div class="qrcode-box" :class="{ 'qrcode-box--refreshing': isQrRefreshing }">
      <img v-show="wxUrl != ''" class="qrcode" :src="wxUrl" alt="" />
      <div
        v-show="refresh.show || isQrRefreshing"
        class="div_refresh cp_us"
        :class="{ 'div_refresh--busy': isQrRefreshing }"
        @click="refreshQrCode()"
      >
        <i class="iconfont">&#xe75f;</i>
        <span v-if="isQrRefreshing">正在刷新二维码…</span>
        <span v-else>二维码已过期<br />点击刷新重新获取</span>
      </div>
    </div>
    <div class="div_bottom flex_center">
      <p>
        登录/注册即表示同意
        <a :href="agreement.uagreem" target="_blank" class="hover_color_t"
          >《服务协议》</a
        >
        和
        <a :href="agreement.pp" target="_blank" class="hover_color_t"
          >《隐私政策》</a
        >
      </p>
    </div>
    <el-button class="wx-login" @click="router.replace({ name: 'login' })">
      <i class="iconfont">&#xe70e;</i>
      手机号登录
    </el-button>
  </div>
</template>

<script setup>
import { ref, onUnmounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";

import { getQRCode, wXFOALogin } from "@/api/api.js";

import { goBackToSource, detectDeviceType } from "@/utils/index";

const router = useRouter();
const route = useRoute();
const agreement = {
  uagreem: process.env.VUE_APP_HELP_REDIRECT + "servicearg/uagreem.html",
  pp: process.env.VUE_APP_HELP_REDIRECT + "servicearg/pp.html",
};
//微信二维码
const wxUrl = ref("");
//微信登录数据
let wxQrCodeInfo = {};
let isMounted = true;
//微信登录轮询定时器
let timeout = null;
// 获取二维码失败后的重试定时器
let qrRetryTimer = null;

let refresh = ref({
  show: false,
  time: 100, //100秒刷新一次
  nowTime: 0,
});
// 手动刷新二维码进行中，防止连点重复请求
const isQrRefreshing = ref(false);

init();
function init(){
  if(detectDeviceType()){
    // 如果是移动设备，则直接跳转到手机号登录页面
    router.replace({
      name: "login",
      query: route.query
    })
  }else {
    isMounted = true;
    getWxQrCode(() => {
      getWxLogin();
    });
  }
}

//获取微信二维码（失败或异常时每 5s 重试一次）
function getWxQrCode(callBack) {
  if (!isMounted) return;
  getQRCode()
    .then((res) => {
      if (!isMounted) return;
      if (res.code == 200 && res.data) {
        clearQrRetryTimer();
        wxUrl.value = res.data.ticketUrl;
        wxQrCodeInfo = res.data;
        callBack();
      } else {
        scheduleQrCodeRetry(callBack);
      }
    })
    .catch(() => {
      if (!isMounted) return;
      scheduleQrCodeRetry(callBack);
    });
}

//获取微信登录数据
function getWxLogin() {
  clearWxLoginInterval();
  timeout = setInterval(() => {
    if (refresh.value.nowTime >= refresh.value.time) {
      clearInterval(timeout);
      timeout = null;
      refresh.value.show = true;
      return;
    }
    refresh.value.nowTime += 1;
    wXFOALogin(wxQrCodeInfo.ticket).then((res) => {
      if (res.code == 200) {
        clearInterval(timeout);
        timeout = null;
        ElMessage({
          icon: "SuccessFilled",
          type: "success",
          message: "登录成功",
        });
        localStorage.setItem("wxLogin", JSON.stringify(res.data));
        setTimeout(() => {
          if (res.data.newUser) {
            router.push({
              name: "setPhone",
            });
          } else {
            localStorage.clear();
            goBackToSource(res.data.token);
          }
        }, 1000);
      }
    });
  }, 1000);
}

function refreshQrCode() {
  if (isQrRefreshing.value) return;
  isQrRefreshing.value = true;
  refresh.value.nowTime = 0;
  refresh.value.show = false;
  getWxQrCode(() => {
    getWxLogin();
    isQrRefreshing.value = false;
  });
}


// 定时重试获取二维码
function scheduleQrCodeRetry(callBack) {
  if (!isMounted) return;
  clearQrRetryTimer();
  qrRetryTimer = setTimeout(() => {
    qrRetryTimer = null;
    if (isMounted) getWxQrCode(callBack);
  }, 2000);
}

// 清除微信登录轮询定时器
function clearWxLoginInterval() {
  if (timeout) {
    clearInterval(timeout);
    timeout = null;
  }
}

// 清除二维码重试定时器
function clearQrRetryTimer() {
  if (qrRetryTimer) {
    clearTimeout(qrRetryTimer);
    qrRetryTimer = null;
  }
}

onUnmounted(() => {
  isMounted = false;
  isQrRefreshing.value = false;
  clearWxLoginInterval();
  clearQrRetryTimer();
});
</script>

<style lang='scss' scoped>
.div_wxLogin {
  font-size: 0;
  padding-top: -40px;
  box-sizing: border-box;
  text-align: center;
  .h3_title {
    line-height: 50px;
    font-weight: 600;
    font-size: 36px;
    color: #222222;
  }
  .p_explain {
    line-height: 25px;
    font-weight: 500;
    font-size: 18px;
    color: #919191;
    margin: 10px 0px 40px;
  }
  .qrcode-box--refreshing {
    pointer-events: none;
  }
  .qrcode-box {
    width: 340px;
    height: 340px;
    background: #ffffff;
    border-radius: 18px;
    border: 2px solid #f0f0f0;
    box-sizing: border-box;
    padding: 20px;
    margin: 0 auto;
    position: relative;
    .qrcode {
      width: 100%;
      height: 100%;
    }
    .div_refresh {
      width: 100%;
      height: 100%;
      border-radius: 18px;
      position: absolute;
      top: 0;
      left: 0;
      color: #fff;
      background: rgba(0, 0, 0, 0.8);
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      i {
        font-size: 64px;
      }
      span {
        font-size: 18px;
        margin-top: 18px;
      }
    }
    .div_refresh--busy {
      cursor: wait;
    }
  }
  .div_bottom {
    margin: 27px 0 0;
    p {
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      a {
        text-decoration: none;
      }
    }
    .hover_color_t {
      color: #333333 !important;
    }
  }
  .wx-login {
    width: 100%;
    height: 60px;
    margin-top: 65px;
    color: #000000;
    background: #ffffff;
    border-radius: 16px;
    font-size: 16px;
    border: 2px solid #eaeaea;
    box-sizing: border-box;
    i {
      font-size: 18px;
      margin-right: 12px;
    }
  }
}
@media screen and (max-width: 768px) {
  .div_wxLogin {
    width: 100%;
    height: 100%;
    padding: 20% 0.2rem 0;
    .h3_title {
      line-height: 0.4rem;
      font-size: 0.24rem;
    }
    .p_explain {
      line-height: 0.2rem;
      font-size: 0.12rem;
      margin: 0.1rem 0px 0.2rem;
    }
    .qrcode-box {
      width: 2.5rem;
      height: 2.5rem;
      border-radius: 0.12rem;
      border: 0.02rem solid #f0f0f0;
      padding: 0.15rem;
      .div_refresh {
        border-radius: 0.12rem;
        i {
          font-size: 0.4rem;
        }
        span {
          font-size: 0.14rem;
          margin-top: 0.14rem;
        }
      }
    }
    .div_bottom {
      margin: 0.2rem 0 0;
      p {
        font-size: 0.12rem;
      }
    }
    .wx-login {
      height: 0.6rem;
      margin-top: 0.3rem;
      border-radius: 0.1rem;
      font-size: 0.16rem;
      border: 0.02rem solid #eaeaea;
      i {
        font-size: 0.18rem;
        margin-right: 0.1rem;
      }
    }
  }
}
</style>
